<div class="dialog-agent">
  <div mat-dialog-content class="">
    <div>
      <div class="w-100 d-inline-block text-center pt-2 pb-4">
        <i class="fas fa-exclamation-triangle fa-2x mb-2 text-warning"></i> <br>
        <b class="text-warning h4 px-2">{{data.staticMessages.title}}</b>
      </div>
    </div>

    <div class="w-100 d-inline-block">
      <p class="p-3 m-0 bg-light text-center text-dark" [innerHTML]="data.staticMessages.body"></p>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CLOSE' | translate }}</span>
    </button>
  </div>
</div>
